import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const descontoFlexService = 
{
    deletarExcelDescontoFlex(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'descontoflex/excel/deletar', 'excelDescontoFlexDeletar');
    },
    salvarExcelDescontoFlex(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'descontoflex/excel', 'excelDescontoFlex');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('descontoflex/excel');
    },
    enviarDescontoFlexAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('descontoflex/eventGrid', {});
    }
}

export default descontoFlexService;